import apiClient from '../../api/apiClient';
import { Endpoints } from './constants';

async function postNoBody(url) {
    const response = await apiClient.post(url);
    return response.data;
}

async function postWithBody(url, body) {
    const response = await apiClient.post(url, body);
    return response.data;
}

const c = Endpoints.sessions.controls;

export const showQuestion = (id) => postNoBody(c.showQuestion(id));
export const hideQuestion = (id) => postNoBody(c.hideQuestion(id));
export const showAnswer = (id) => postNoBody(c.showAnswer(id));
export const hideAnswer = (id) => postNoBody(c.hideAnswer(id));
export const showRating = (id) => postNoBody(c.showRating(id));
export const hideRating = (id) => postNoBody(c.hideRating(id));
export const showRoundDescription = (id) => postNoBody(c.showRoundDescription(id));
export const hideRoundDescription = (id) => postNoBody(c.hideRoundDescription(id));
export const showMedia = (id, withTimer = false) => postWithBody(c.showMedia(id), { withTimer });
export const hideMedia = (id) => postNoBody(c.hideMedia(id));
export const selectMedia = (id, mediaId) => postWithBody(c.selectMedia(id), { mediaId });
export const startTimer = (id) => postNoBody(c.startTimer(id));
export const pauseTimer = (id) => postNoBody(c.pauseTimer(id));
export const nextQuestion = (id) => postNoBody(c.nextQuestion(id));
export const selectQuestion = (id, orderId) => postWithBody(c.selectQuestion(id), { orderId });
export const nextRound = (id) => postNoBody(c.nextRound(id));
export const selectRound = (id, orderId) => postWithBody(c.selectRound(id), { orderId });
export const nextTeam = (id) => postNoBody(c.nextTeam(id));
export const selectTeam = (id, orderId) => postWithBody(c.selectTeam(id), { orderId });
export const throwQuestion = (id) => postNoBody(c.throwQuestion(id));
export const applyCorrectAnswer = (id) => postNoBody(c.applyCorrectAnswer(id));

export async function updateStatus(democracyId, newStatus) {
    const response = await apiClient.put(Endpoints.democracies.updateStatus(democracyId), { newStatus });
    return response.data;
}

export async function updateTeamRuntime(democracyId, teamId, body) {
    const response = await apiClient.put(Endpoints.sessions.teamRuntime(democracyId, teamId), body);
    return response.data;
}

export async function excludeTeam(democracyId, teamId) {
    const response = await apiClient.post(Endpoints.sessions.teamExclude(democracyId, teamId));
    return response.data;
}

export async function deleteTeamSanction(democracyId, teamId, sanctionId) {
    const response = await apiClient.delete(Endpoints.sessions.teamSanctionDelete(democracyId, teamId, sanctionId));
    return response.data;
}

export async function adminBuySanction(democracyId, body) {
    const response = await apiClient.post(Endpoints.sessions.sanctionBuy(democracyId), body);
    return response.data;
}
